<mat-form-field class="full-width">
  <mat-label>{{ 'PRODUCTION_ORDER.CUSTOM_SETTINGS.NAME_GENERATION' | bmsTranslate }}</mat-label>
  <vdw-object-selection
    [formControl]="nameGenerationPattern"
    [objectName]="'PRODUCTION_ORDER.CUSTOM_SETTINGS.NAME_GENERATION' | bmsTranslate | lowercase"
    (selectClicked)="selectNameGenerationPattern()"
    (clearClicked)="clearNameGenerationPattern()"
  ></vdw-object-selection>
</mat-form-field>
